import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

// Add a size
export const addSize = async (token, data) => {
  const url = `${BASE_URL}/products/products-sizes/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

// Get all sizes
export const getAllSizes = async (token, params = {}) => {
  const url = `${BASE_URL}/products/products-sizes/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

// Get a specific size by ID
export const getSize = async (token, sizeId) => {
  const url = `${BASE_URL}/products/products-sizes/${sizeId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

// Update a size
export const updateSize = async (token, data, sizeId) => {
  const url = `${BASE_URL}/products/products-sizes/${sizeId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

// Delete a size
export const deleteSize = async (token, sizeId) => {
  const url = `${BASE_URL}/products/products-sizes/${sizeId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
